<template lang="pug">
.briq-form-element
  label(:for="name") {{label}}
  briq-required-and-optional-markers(:isRequired="this.$attrs.required" :isDisabled="this.$attrs.disabled || this.$attrs.readonly" :hideOptionalMarker="hideOptionalMarker" :label="label")
  briq-tooltip(:help="help")
  .input-container(v-for="(value, index) in values")
    input.form-element(
      :key="index"
      :style="index !== 0 ? { marginTop: '10px' } : {}"
      :name="nameField"
      :id="getId(index)"
      v-bind="$attrs"
      v-model="values[index]"
      :disabled="disabled")
    span.remove-field(@click="removeLine(index)" :class="{ disabled }")
      svg.icon.icon-input-min-icon
        use(xlink:href="#icon-input-min-icon")
  button.add-line.button.button--confirm(type="button" :disabled="disabled" @click="addLine") Add line
  .form-help-text {{ error }}
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    name: String,
    label: String,
    hideOptionalMarker: {
      type: Boolean,
      default: false,
    },
    help: String,
    error: String,
    disabled: Boolean,
  },
  data() {
    return { values: [''] }
  },
  computed: {
    nameField() {
      return this.name + '[]'
    },
  },
  methods: {
    getId(index) {
      return `${this.name}-${index}`
    },
    addLine() {
      this.values.push('')
    },
    removeLine(index) {
      if (this.disabled) return
      if (this.values.length > 1) {
        this.values.splice(index, 1)
      } else {
        this.values[0] = ''
      }
    },
  },
  created() {
    if (this.$attrs.value && this.$attrs.value.length && this.$attrs.value.length > 0) {
      this.values = this.$attrs.value
    }
  },
}
</script>

<style scoped lang="stylus">

.add-line {
  margin-top: 10px;
}

.input-container {
  position: relative;
}

iconSize = 1em;

.remove-field {
  position: absolute;
  right: iconSize;
  top: calc(50% - iconSize / 2);
  cursor: pointer;
  display: flex;

  &.disabled {
    cursor: not-allowed;
  }
}
</style>
